<template>
  <div class="app" style="text-transform: uppercase;font-family:Sans-Serif; font-size: 15px;">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile v-if="navHide"/>
      <b-link class="navbar-brand" to="#">
        <h5>লালমনিরহাট</h5>

        <!-- <p><small>চাঁদপুর</small></p> -->
        <!-- <h4>BM Recruiting</h4> -->
        <!-- <img class="navbar-brand-full" src="../static/logo.png" width="89" height="25" alt="CoreUI Logo"> -->
        <!-- <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo"> -->
      </b-link>
      <SidebarToggler  class="d-md-down-none" display="lg" v-if="navHide"/>
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item> -->
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item> -->
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!-- <AsideToggler class="d-lg-none" mobile /> -->
    </AppHeader>
    <div class="app-body">
      <div v-if="navHide">
        <AppSidebar fixed>
          <SidebarHeader/>
          <SidebarForm/>
          <SidebarNav v-if="$user.type == 1 && $user.user_type == 'admin'" :navItems="navAdmin"></SidebarNav>
          <SidebarNav v-else-if="$user.type == 1 && $user.user_type == 'holding'" :navItems="navHolding"></SidebarNav>
          <SidebarNav v-else-if="$user.type == 2 && $user.user_type == ''" :navItems="nav"></SidebarNav>
          <SidebarFooter/>
          <SidebarMinimizer/>
        </AppSidebar>
      </div>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="">Paurasheba</a>
        <!-- <span class="ml-1">&copy; 2019 BMAMS</span> -->
      </div>
      <div class="ml-auto">
        <span class="mr-1">Developed and managed by</span>
        <a href="http://orangebd.com/">Orangebd</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import navAdmin from '@/_navAdmin'
import navMeyor from '@/_navMeyor'
import navSochib from '@/_navSochib'
import navHolding from '@/_navHolding'
import navOperatorMarket from '@/_navOperatorMarket'
import navOperatorWater from '@/_navOperatorWater'

import { SidebarToggler, SidebarForm, SidebarMinimizer, Aside as AppAside, AsideToggler, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import AppSidebar from '../Sidebar/Sidebar'
import SidebarNav from '../Sidebar/SidebarNav'
import SidebarHeader from '../Sidebar/SidebarHeader'
import SidebarFooter from '../Sidebar/SidebarFooter'
import AppHeader from '../Header/Header'
import TheFooter from '../Footer/Footer'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { mapGetters } from "vuex"
export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      navAdmin: navAdmin.items,
      navMeyor: navMeyor.items,
      navHolding: navHolding.items,
      navSochib: navSochib.items,
      navOperatorMarket: navOperatorMarket.items,
      navOperatorWater: navOperatorWater.items,
      item2:'',
      navHide:true,
    }
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    ...mapGetters(["userinfo","authuser"]),
  },
  methods:{

    allRole(){
      this.$store.dispatch('ALL_USER_ROLE')
    },
    getPermission(){
        this.$store.dispatch('ALL_USER_ROLE2')
        .then(response=>{
          if(response.data.id!=2){
            this.navHide=true;
          }
        })
    },

    // menuAdd(){
    //   var roles =  this.user_roles
    //   this.nav[12].children = []
    //   roles.forEach(element => {
    //     var a = {
    //       name: element.name,
    //       url: '/role-permission/'+element.id,
    //       icon: 'fa fa-money'
    //     }
    //     this.nav[12].children.push(a)
    //   })
    // }
  },
  watch:{
    $user:function(){

    }

  },
  mounted(){
    //console.log(user)
  }
}
</script>
<style scoped>
  @import url('https://fonts.maateen.me/kalpurush/font.css');
  h5{font-family: 'Kalpurush', Arial, sans-serif; font-size: 20px;}
  .main .container-fluid{ padding:0 15px}
  @media screen and (max-width: 575px){
    .app-header .navbar-brand {
        position: absolute;
        top: 4px;
        left: 40%;
        margin-left: -77.5px;
    }
  }
</style>
